// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 134) return "app-launcher/actiondesk.8fa479868d282f2baf0e.min.js";
	if (chunkId === 902) return "app-launcher/902.9cc1f1205061a50da104.min.js";
	if (chunkId === 9) return "app-launcher/static.53b141d0a2fc2d353d41.min.js";
	if (chunkId === 260) return "app-launcher/260.3c423dff2e3b20f5ff57.min.js";
	if (chunkId === 807) return "app-launcher/dynamic-locale-jp-json.72b0c0a2f0aa904fa19f.min.js";
	if (chunkId === 138) return "app-launcher/md-editor.bbf5b5de9eadf536ec83.min.js";
	if (chunkId === 176) return "app-launcher/charts.bcc643ea355923739f87.min.js";
	if (chunkId === 522) return "app-launcher/maps.f0d9056da8b031882c45.min.js";
	if (chunkId === 84) return "app-launcher/dendrogram.35ad95f1df0dc1ea63b4.min.js";
	if (chunkId === 77) return "app-launcher/graph.44307855224844e8e17c.min.js";
	if (chunkId === 108) return "app-launcher/sankey.9c2094337ae1d23baace.min.js";
	if (chunkId === 164) return "app-launcher/164.388a3e92bf4c065b45cf.min.js";
	if (chunkId === 36) return "app-launcher/36.086b3a5633ed1262c052.min.js";
	if (chunkId === 577) return "app-launcher/577.2f6e3f425c5ab7bc823e.min.js";
	if (chunkId === 651) return "app-launcher/651.4cdf7c7847ff795fc54a.min.js";
	if (chunkId === 616) return "app-launcher/616.9d08e2e3b8cea337fb8a.min.js";
	if (chunkId === 973) return "app-launcher/973.1cbd28897ddf8da2b18f.min.js";
	// return url for filenames based on template
	return undefined;
};